import React, { useState } from 'react';
import { ActionsDropdown } from '@components/library/dropdown/index';
import { ActionDropdownItem } from '@components/library/dropdown_item/index';
import { TertiaryIconButton } from '@components/library/button/index';
import PortalForm from './portal_form';

interface PortalSettingsProps {
  editMode: boolean;
  libraryName: string;
  showSettingsDropdown: boolean;
  setShowSettingsDropdown: SetStateDispatch<boolean>;
  showForm: boolean;
  toggleEditMode: () => void;
  toggleForm: () => void;
}

const PortalSettings: React.FunctionComponent<PortalSettingsProps> = (props) => {
  const [closeDropdown, setCloseDropdown] = useState(false);

  const anchorElement = (
    <TertiaryIconButton
      className="ellipsis-button"
      icon="bff-ellipsis"
      iconSize={20}
    />
  );

  return (
    <>
      <ActionsDropdown
        anchorElement={anchorElement}
        className="portal-header__dropdown"
        closeCallback={(): void => setCloseDropdown(false)}
        closeDropdown={closeDropdown}
        openOnClick
        openOnHover={false}
        userDevice={BFG.currentUser.device}
      >
        <ActionDropdownItem
          icon="bff-settings"
          name="portal-settings"
          onChoose={(): void => {
            props.toggleForm();
            setCloseDropdown(true);
          }}
        >
          {bfTranslate("Portal Settings")}
        </ActionDropdownItem>
        <ActionDropdownItem
          icon="bff-show"
          name="edit-mode"
          onChoose={(): void => {
            props.toggleEditMode();
            setCloseDropdown(true);
          }}
        >
          {props.editMode ? bfTranslate("Switch to Preview Mode") : bfTranslate("Switch to Edit Mode")}
        </ActionDropdownItem>
      </ActionsDropdown>
      {props.showForm && <PortalForm closeModal={props.toggleForm} libraryName={props.libraryName} />}
    </>
  );
};

export default PortalSettings;
